export const version = "ethers/5.5.4";
//# sourceMappingURL=_version.js.map